import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

// Amplify/Cognito bootstrap for authentication.
// User profile data is loaded via the REST user API.

let isAmplifyConfigured = false;

export const configureAmplify = () => {
  console.log('Configuring Amplify (Cognito)');
  try {
    if (!process.env.REACT_APP_COGNITO_USER_POOL_ID) {
      return false;
    }

    if (!process.env.REACT_APP_COGNITO_CLIENT_ID) {
      return false;
    }

    const amplifyConfig = {
      Auth: {
        Cognito: {
          userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        },
      },
    };

    Amplify.configure(amplifyConfig);

    const customStorage = {
      setItem: (key: string, value: string) => {
        localStorage.setItem(key, value);
        return Promise.resolve();
      },
      getItem: (key: string) => {
        const value = localStorage.getItem(key);
        return Promise.resolve(value);
      },
      removeItem: (key: string) => {
        localStorage.removeItem(key);
        return Promise.resolve();
      },
      clear: () => {
        localStorage.clear();
        return Promise.resolve();
      },
    };

    cognitoUserPoolsTokenProvider.setKeyValueStorage(customStorage);

    console.log('✅ Amplify configured with localStorage for token persistence');
    isAmplifyConfigured = true;
    return true;
  } catch (error) {
    console.error('❌ Failed to configure Amplify:', error);
    return false;
  }
};

export const isConfigured = () => isAmplifyConfigured;
